import {
	applySnmpConfigurationFilter,
	focusSnmpConfiguration,
	openSnmpConfigurationSection,
} from './adapter';
import {
	openSnmpConfigurationCreateModal,
	openSnmpConfigurationEditModal,
	openSnmpConfigurationDeleteModal,
} from './modal';
import {resolveSnmpConfiguration} from './resolver';

/**
 * SNMP profiles.
 *
 * SNMP profiles under Templates. Named snmp_configuration so "snmp"
 * and "snmp profile" keep answering as the Site fields of those
 * names. One profile is Canvas's Default and cannot be deleted -
 * Canvas refuses that itself rather than it being predicted here.
 *
 * Declares no fields: the agent finds a profile and opens the form rather
 * than filling it in.
 */
const snmpConfigurationPlugin = {
	id: 'snmp_configuration',
	version: 1,
	commandVersion: 1,
	resource: 'snmp_configuration',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.snmp_profiles': openSnmpConfigurationSection,
	},
	resolvers: {
		snmp_configuration: resolveSnmpConfiguration,
	},
	filters: {
		snmp_configuration: (command) =>
			applySnmpConfigurationFilter(command.params?.query),
	},
	focusHandlers: {
		snmp_configuration: (command) =>
			focusSnmpConfiguration(command.params?.entity_id),
	},
	modals: {
		'snmp_configuration.create': openSnmpConfigurationCreateModal,
		'snmp_configuration.edit': openSnmpConfigurationEditModal,
		'snmp_configuration.delete': openSnmpConfigurationDeleteModal,
	},
};

export default snmpConfigurationPlugin;
